import React from 'react';
import ReactDom from 'react-dom';
import Loadable from 'react-loadable';
import { useUserPageContextState } from '../../../user';

const LoadableCookieAccept = Loadable({
	loader: () => import('./CookieAccept').then((c) => c.CookieAccept),
});

export function CookieAcceptPortal() {
	const { hasAcceptedCookie } = useUserPageContextState();
	const el = document.querySelector('.cookie-accept');

	if (!el || hasAcceptedCookie) {
		return null;
	}

	return ReactDom.createPortal(<LoadableCookieAccept />, el);
}
